import React from 'react';
import { type KeyAction } from './types';
import { useKeyActions } from './useKeyActions';

/**
 * A KeyActions HOC which can be used to register key actions in class-based
 * React components.  This is just a thin wrapper around `useKeyActions()`.
 */
export const KeyActions: React.FC<{ actions: KeyAction[]; children?: React.ReactNode }> = (
  props,
) => {
  useKeyActions(props.actions);
  return <>{props.children}</>;
};
